import { classNames } from "primereact/utils";
import styles from "./FloatingPanel.module.scss";
import { motion } from "framer-motion";

type PanelVariant = "default" | "glass";

interface IFloatingPanelProps {
  className?: string;
  title?: string;
  children: React.ReactNode;
  maxHeight?: number;
  variant?: PanelVariant;
}

export const FloatingPanel = ({
  className,
  title,
  children,
  maxHeight,
  variant = "default",
}: IFloatingPanelProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{
        duration: 0.6,
        ease: [0.4, 0, 0.2, 1], // cubic-bezier(0.4, 0, 0.2, 1)
      }}
      className={classNames(styles.root, className, {
        [styles.root_glass]: variant === "glass",
      })}
      style={{
        overflow: "hidden",
        maxHeight,
      }}
    >
      {title && <h1>{title}</h1>}
      {children}
    </motion.div>
  );
};
